export default __webpack_public_path__ + "static/hands-with-plant--prod-3c81c34f5cc3fca1045ef7ed1d9bc348.jpg";